import classNames from "classnames"
import type {
  Ref,
  ComponentPropsWithoutRef,
} from "react"
import { forwardRef } from "react"

import styles from "./InfoButton.module.scss"
import { useInfoButtonContext } from "./InfoButtonContext"
import type { SizePresetKey } from "./SizePreset"
import {
  Dialog,
  DialogBody,
  DialogCloseX,
  DialogContent,
  DialogHeading,
  DialogTrigger,
} from "src/floating"
import { InfoOutlineIcon } from "src/icons"

enum SizePreset {
  small = "infoButtonSmall",
  large = "infoButtonLarge",
}

export interface Props extends ComponentPropsWithoutRef<"button"> {
  sizePreset?: SizePresetKey;
  title: string;
}

export const InfoButton = forwardRef<HTMLButtonElement, Props>(
  function InfoButton(props: Props, propRef: Ref<HTMLButtonElement>) {
    const infoButtonContext = useInfoButtonContext()

    const {
      title,
      children,
      sizePreset = infoButtonContext.sizePreset,
      ...htmlButtonProps
    } = props

    const className = classNames(
      props.className,
      styles.infoButton,
      styles[SizePreset[sizePreset]],
    )

    return (
      <Dialog>
        <DialogTrigger
          {...htmlButtonProps}
          className={className}
          ref={propRef}
        >
          <InfoOutlineIcon className={styles.infoIcon} />
        </DialogTrigger>
        <DialogContent>
          <DialogHeading>
            {title}
            <DialogCloseX />
          </DialogHeading>
          <DialogBody>
            {children}
          </DialogBody>
        </DialogContent>
      </Dialog>
    )
  },
)
